import http from '../utils/http';
import { DEPARTMENT_URL } from '../constants/endpoints';

export async function fetchAll() {
  return await http.get(DEPARTMENT_URL);
}
